import * as _ from 'lodash';
import moment from 'moment-timezone';
import 'moment-business-days';

const BandwangoHelpers = {
	run(helpers, options = {}) {
		const helperList = {
			swal: options => this.swal(options),
			notify: options => this.notify(options)
		};

		if(helpers instanceof Array) {
			for (const index in helpers) {
				if(helperList[helpers[index]])
					return helperList[helpers[index]](options);
			}
		}
		else if(helperList[helpers]) return helperList[helpers](options);
	},

	notify(options = {}) {
		One.helpers('notify', options);
	},
	
	swal(options = {}) {
		return new Promise((resolve, reject) => {
			// Set default properties
			const toast = Swal.mixin({
				buttonsStyling: false,
				customClass: {
					confirmButton: 'btn btn-success m-1',
					cancelButton: 'btn btn-danger m-1',
					input: 'form-control'
				}
			});

			if(options.type == 'delete') {
				const defaultOptions = {
					title: 'Are you sure?',
					text: 'You will not be able to recover this imaginary file!',
					icon: 'warning',
					showCancelButton: true,
					customClass: {
						confirmButton: 'btn btn-danger m-1',
						cancelButton: 'btn btn-light m-1'
					},
					confirmButtonText: options.confirmButtonText || 'Yes, delete it!',
					html: false,
					preConfirm: e =>
							new Promise(resolve => {
								setTimeout(() => {
									resolve();
								}, 50);
							})
				};

				// options = {...defaultOptions, ...options};
				options = Object.assign(defaultOptions, options);
			}
			else if(options.type == 'question') {
				const defaultOptions = {
					icon: 'question',
					showCancelButton: true,
					customClass: {
						confirmButton: 'btn btn-success m-1',
						cancelButton: 'btn btn-light m-1'
					},
					confirmButtonText: 'Yes!'
				};

				// options = {...defaultOptions, ...options};
				options = Object.assign(defaultOptions, options);
			}

			delete options.type;

			toast
					.fire(options)
					.then(result => {
						resolve(result);
					})
					.catch(error => {
						reject(error);
					});
		});
	}
};

const Bandwango = {
	config: {},

	helpers(helpers, options = {}) {
		return BandwangoHelpers.run(helpers, options);
	},

	// private only use getDiff
	deepDiff(a, b, r, reversible) {
		const vm = this;
		_.each(a, (v, k) => {
			if(b[k] && b[k] !== undefined && !Array.isArray(b[k])) {
				// see if values in array changed
				// already checked this or equal...
				if(r.hasOwnProperty(k) || b[k] === v) return;

				// if an attribute change in a child object then pass back the whole object
				if(_.isObject(v)) {
					const t = vm.getDiff(v, b[k], reversible);
					if(!_.isEmpty(t)) r[k] = v;
				}
				else r[k] = v;
			}
			else {
				// let first = v[0] || b[k][0];
				// if( _.isObject(first) ) {
				// 	// if anything changed in the array then return the whole array
				// 	let changed = false;
				// 	if( v.length != b[k].length ) {
				// 		changed = true;
				// 	} else {
				// 		for(let i = 0; i<v.length; i++) {
				// 			let d = vm.getDiff(v[i], b[k][i], reversible);
				// 			if( !_.isEmpty(d) ) changed = true;
				// 		}
				// 	}
				//
				// 	if( changed )
				// 		r[k] = v;
				// } else {
				// 	let d = b[k].filter(x => !v.includes(x));
				// 	if( d && d.length )
				// 		r[k] = v;
				// }
				r[k] = v; // vue watch is not watching this deep, Always pass back
			}
		});
	},

	getDiff(a, b, reversible) {
		const r = {};
		this.deepDiff(a, b, r, reversible);
		if(reversible) this.deepDiff(b, a, r, reversible);
		return r;
	},

	computedObject(obj) {
		const c = { ...obj };
		Object.keys(obj).forEach(k => {
			// if( Array.isArray(c[k]) && c[k][0] && _.isObject(c[k][0]) ) {
			// 	c[k].forEach((x, i) => c[k][i] = this.computedObject(x));
			// }
			if(_.isObject(obj[k]) && !Array.isArray(obj[k]))
				c[k] = this.computedObject(obj[k]);
		});
		return c;
	},

	prettyId(str) {
		return str
				.match(/([A-Z][^.]?[^A-Z]*)|(\.?[a-z]*[^A-Z])/g)
				.join(' ')
				.replace(/[\.\_]/g, ' ')
				.match(/\w*\w/g)
				.map(s => s.charAt(0).toUpperCase() + s.substring(1))
				.join(' ');
	},

	ucwords(str) {
		if(str && typeof str === 'string') {
			return str
					.replace(/([A-Z])/g, ' $1')
					.trim()
					.toLowerCase()
					.replace(/(?: )[^\s]|^./g, a => a.toUpperCase());
		}
	},

	dateServerFormat(date) {
		return moment(date, 'YYYY-MM-DD h:mm a').format('YYYY-MM-DD HH:mm:ss');
	},

	dateToUtc(
			date,
			returnFormat = 'YYYY-MM-DD HH:mm:ss',
			inputFormat = 'YYYY-MM-DD h:mm a'
	) {
		return date
				? moment
						.tz(date, inputFormat, this.getTimeZone())
						.utc()
						.format(returnFormat)
				: '';
	},

	dateToUtcDateOnly(
			date,
			returnFormat = 'YYYY-MM-DD',
			inputFormat = 'YYYY-MM-DD'
	) {
		return date
				? moment
						.tz(date, inputFormat, this.getTimeZone())
						.utc()
						.format(returnFormat)
				: '';
	},

	dateToLocal(date, fromNow = false, returnFormat = 'YYYY-MM-DD h:mm a') {
		if(!date) return '';

		if(fromNow) {
			return moment
					.utc(date)
					.tz(this.getTimeZone())
					.fromNow();
		}

		return moment
				.utc(date)
				.tz(this.getTimeZone())
				.format(returnFormat);
	},

	getTimeZone() {
		return this.config.timeZone || 'America/Denver'; // default
	},

	copyToClipBoard(val) {
		const textarea = document.createElement('textarea');
		textarea.textContent = val;
		document.body.appendChild(textarea);

		const selection = document.getSelection();
		const range = document.createRange();
		range.selectNode(textarea);
		selection.removeAllRanges();
		selection.addRange(range);

		console.log('copy success', document.execCommand('copy'));
		selection.removeAllRanges();
		document.body.removeChild(textarea);

		One.helpers('notify', {
			align: 'center',
			type: 'success',
			icon: 'fa fa-check mr-1',
			message: 'Copied to clipboard.'
		});
	},

	truncateFilter(text, length, clamp) {
		clamp = clamp || (length > 0 ? '...' : '');
		const node = document.createElement('div');
		node.innerHTML = text;
		const content = node.textContent;
		return content.length > length + clamp.length
				? content.slice(0, length) + clamp
				: content;
	},

	nl2brFilter(text) {
		return text ? text.replace(/\n/g, '<br>') : text;
	},

	phoneFilter(text) {
		if(!text) return text;
		if(
				text.substring(0, 1) !== '+' ||
				typeof intlTelInput.utils === 'undefined'
		) {
			if(text && text.length > 10) {
				return text
						? text
								.replace(/[^0-9]/g, '')
								.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2) $3-$4')
						: text;
			}
			return text
					? text
							.replace(/[^0-9]/g, '')
							.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
					: text;
		}
		return intlTelInput.utils.formatNumber(
				text,
				null,
				intlTelInput.utils.numberFormat.INTERNATIONAL
		);
	},
	prettyFilter(value) {
		return JSON.stringify(JSON.parse(value), null, 2);
	},

	phoneDirective: {
		twoWay: true, // this transformation applies back to the vm
		bind(el) {
			const handler = () => {
				el.value = Bandwango.phoneFilter(el.value);
			};
			el.addEventListener('input', handler);
			setTimeout(() => {
				handler(); // call first time bind
			}, 150);
		}
	},

	moneyFilter(text, prefix = false) {
		if(text && typeof text === 'string') text = text.replace(/[^0-9.,-]/g, '');

		if(!text) return '';

		let total = parseFloat(text).toFixed(2); // removed decimal. Make sure it's always at 2 to end
		// total /= Math.pow(10, 2);
		let neg = false;
		if(total < 0) {
			neg = true;
			total = Math.abs(total);
		}
		return (
				(prefix || '') +
				(neg ? '-' : '') +
				parseFloat(total, 10)
						.toFixed(2)
						.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
						.toString()
		);
	},

	moneyDirective: {
		twoWay: true, // this transformation applies back to the vm
		bind(el) {
			const handler = () => {
				el.value = Bandwango.moneyFilter(el.value);
			};
			el.addEventListener('input', handler);
			setTimeout(() => {
				handler(); // call first time bind
			}, 150);
		},
		unbind(el) {
			el.removeEventListener('input');
		}
	},

	visualBuilderLink(partnerId, params) {
		let url = `/admin/${partnerId}/template?`;

		if(!params.controller) params.controller = 'modules';

		url += Object.keys(params)
				.map(k => `${k}=${params[k]}`)
				.join('&');

		return url;
	},

	getCallTally() {
		if(!$('#callTally')) return;

		const params = {
			startDateTime: moment()
					.startOf('day')
					.utc()
					.format(),
			endDateTime: moment()
					.add(1, 'day')
					.startOf('day')
					.utc()
					.format(),
			type: 'call'
		};

		$.ajax({
			url: `${utils.apiVersion()}/superAdmin/getCommunicationCounts?${$.param(
					params
			)}`,
			type: 'GET',
			dataType: 'json',
			success(response) {
				$('#callTally .v-badge__badge').text(response);
			},
			error(response) {
			}
		});
	},

	validEmail(email) {
		return /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email);
	},

	capitalize(text, all = true) {
		if(all)
			text = text.split(' ').reduce((c, t) => (c += _.capitalize(t)), '');
		else text = _.capitalize(text);

		return text;
	},

	/**
	 * Auto-determines the most contrasting text color based on the hex color provided
	 * This function also lives at: app/Components/Shared/helpers.js
	 * @param hex - Hex color value
	 * @returns {string|string} - Black or white (#000000 or #FFFFFF)
	 */
	getContrastTextColor(hex) {
		// checkout uses a greyish tone: #4a4a4a
		if(!hex) return '#4a4a4a';

		// Remove '#' from the input if present
		const cleanHexColor = hex.replace('#', '');

		// Validate that the input is a valid 3 or 6 character hex color code
		// if (!/^([0-9A-Fa-f]{3}){1,2}$/.test(cleanHexColor)) {
		//   throw new Error('Invalid hex color code');
		// }

		// Convert 3 character hex color code to 6 character hex color code
		const sixCharHexColor =
				cleanHexColor.length === 3
						? cleanHexColor
								.split('')
								.map((char) => char + char)
								.join('')
						: cleanHexColor;

		// Calculate the relative luminance of the color
		const r = parseInt(sixCharHexColor.substring(0, 2), 16) / 255;
		const g = parseInt(sixCharHexColor.substring(2, 4), 16) / 255;
		const b = parseInt(sixCharHexColor.substring(4, 6), 16) / 255;

		const gammaCorrect = (value) =>
				value <= 0.03928
						? value / 12.92
						: Math.pow((value + 0.055) / 1.055, 2.4);

		const rCorrect = gammaCorrect(r);
		const gCorrect = gammaCorrect(g);
		const bCorrect = gammaCorrect(b);

		const luminance = 0.2126 * rCorrect + 0.7152 * gCorrect + 0.0722 * bCorrect;

		// Calculate contrast ratio and determine the most contrasting text color
		const blackContrastRatio = (luminance + 0.05) / 0.05;
		const whiteContrastRatio = 1.2 / (luminance + 0.05); // 1.05 was original

		return whiteContrastRatio >= blackContrastRatio ? '#FFFFFF' : '#000000';
	},
};

export default Bandwango;
